export default __webpack_public_path__ + "static/cart-fc1b3055bb8791addd1a3e6caf9ab499.png";